// Migrated
<script>
export default defineNuxtComponent({
  setup () {
    const instance = getCurrentInstance()

    return {
      parent: getCustomComponentParent(instance).ctx,
    }
  },

  props: {
    align: {
      type: String,
      default: 'bottom-right',
    },
  },

  render () {
    return null
  },

  data () {
    return {
      navigationControl: null,
    }
  },

  mounted () {
    this.parent.onload(() => {
      this.navigationControl = new window.mapboxgl.NavigationControl()
      this.parent.map?.addControl(this.navigationControl, this.align)
    })
  },

  beforeUnmount () {
    if (!this.parent.map || !this.navigationControl) {
      return
    }

    try {
      this.parent.map?.removeControl(this.navigationControl)
    } catch {
      //
    }
  },
})
</script>
